import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { AddDeviceForm } from '@/console/features/devices/components/device-drawer/add-device-form';
import {
  TAddDeviceInputSchema,
  TAddDeviceProps,
} from '@/console/features/devices/components/device-drawer/add-device.types';
import { addDeviceInputSchema } from '@/console/features/devices/components/device-drawer/add-device.validation';
import { Form } from '@/shared/components/ui/form/form';
import { TSubmittedData } from '@/shared/components/ui/form/form.types';
import { useUpdateDeviceMutation } from '@/shared/redux/api/assets/devices/devices-api';
import { UpdateDeviceMutation } from '@/shared/types/types.generated';
import { showToastError } from '@/shared/utils/toast';

export const AddDevice: React.FC<TAddDeviceProps> = ({
  handlePopoverClose,
  groupId,
}) => {
  const { t } = useTranslation();
  const [updateDevice] = useUpdateDeviceMutation();

  const handleSubmit = async (data: TSubmittedData<TAddDeviceInputSchema>) => {
    const devices = data.data.devices;

    try {
      const promises: Promise<UpdateDeviceMutation>[] = [];
      devices?.forEach((device) => {
        promises.push(
          updateDevice({
            deviceId: device.deviceId,
            device: { groupId, objectVersion: device.objectVersion + 1 },
          }).unwrap(),
        );
      });
      await Promise.all(promises);
      toast.success(
        t('device:add_device_to_group_success', {
          count: devices?.length,
        }),
      );
      handlePopoverClose();
    } catch {
      showToastError(
        t('device:add_device_to_group_error', {
          count: devices?.length,
        }),
      );
    }
  };

  return (
    <Form<TAddDeviceInputSchema>
      onSubmit={(event) => handleSubmit(event)}
      schema={addDeviceInputSchema}
    >
      {() => <AddDeviceForm onClose={handlePopoverClose} groupId={groupId} />}
    </Form>
  );
};
